export default __webpack_public_path__ + "static/media/polarmenu.80dc7847.webp";